import React, {FC} from 'react';
import styled from 'styled-components';

import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {MacrosDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/macrosDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../libs/shared/ui/src/styles/mixins';
import {MacroModel} from '../../../../models/api/macroModel';
import {MacroTooltipCoordinator} from './macroTooltipCoordinator';

interface MacroDropdownItemProps {
  macro: MacroModel;
  onRunMacro: (macro: MacroModel) => void;
}

const StyledDropdownItemContent = styled(DropdownItemContent)`
  display: flex;
  flex-direction: column;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  ${ellipsis()}
`;

const StyledDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade60};
  ${ellipsis()}
`;

const StyledTitleWrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const MacroDropdownItem: FC<MacroDropdownItemProps> = ({macro, onRunMacro}) => {
  const {trackDataEvent} = useDataEventTracking();

  return (
    <MacroTooltipCoordinator macro={macro} placement="right-start">
      <DropdownItem
        onSelect={() => {
          trackDataEvent(DataEventActionsEnum.SELECT, MacrosDataEventObject.MACRO_LIST, {
            macro_id: macro.id,
          });
          onRunMacro(macro);
        }}
      >
        <StyledDropdownItemContent>
          <StyledTitleWrapperDiv>
            <StyledTitleDiv>{macro.name}</StyledTitleDiv>
          </StyledTitleWrapperDiv>
          <StyledDescriptionDiv>{macro.description}</StyledDescriptionDiv>
        </StyledDropdownItemContent>
      </DropdownItem>
    </MacroTooltipCoordinator>
  );
};
